import { ChangeEvent, Fragment } from 'react';
import {
  Input,
  InputGroup,
  InputGroupText,
  Pagination,
  PaginationItem,
  PaginationLink,
} from 'reactstrap';

interface IProps {
  totalItems: number;
  selectedPage: number;
  totalPages: number;
  pages: number[];
  rowsPerPage: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const PendingActivitiesPagination = ({
  totalItems,
  selectedPage,
  totalPages,
  pages,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}: IProps) => {
  const visiblePages = pages.filter((page) => {
    const isFirstPage = page === 0;
    const isLastPage = page === totalPages - 1;
    const isNearSelectedPage = Math.abs(page - selectedPage) <= 1;
    const isNearStart = selectedPage <= 2 && page <= 4;
    const isNearEnd = selectedPage >= totalPages - 3 && page >= totalPages - 5;

    return (
      isFirstPage ||
      isLastPage ||
      isNearSelectedPage ||
      isNearStart ||
      isNearEnd
    );
  });

  return (
    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mt-3">
      <small className="text-muted">Total de {totalItems} registro(s)</small>

      <div
        className="d-flex flex-wrap align-items-center justify-content-end gap-3"
        style={{ minHeight: 38 }}
      >
        <InputGroup style={{ width: 160 }}>
          <InputGroupText
            className="text-muted fw-semibold"
            style={{ height: 38 }}
          >
            Exibir
          </InputGroupText>
          <Input
            id="rows-per-page"
            type="select"
            value={rowsPerPage}
            onChange={onRowsPerPageChange}
            style={{ height: 38 }}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </Input>
        </InputGroup>

        <Pagination
          className="mb-0 d-flex align-items-center"
          style={{ height: 38, marginTop: 0, marginBottom: 0 }}
        >
          <PaginationItem
            disabled={selectedPage === 0}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <PaginationLink
              previous
              style={{
                height: 38,
                display: 'flex',
                alignItems: 'center',
                marginTop: 0,
                marginBottom: 0,
              }}
              onClick={() => onPageChange(selectedPage - 1)}
            />
          </PaginationItem>

          {visiblePages.map((page, index) => {
            const previousPage = visiblePages[index - 1];
            const hasGap =
              previousPage !== undefined && page - previousPage > 1;

            return (
              <Fragment key={page}>
                {hasGap && (
                  <PaginationItem
                    disabled
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    <PaginationLink
                      style={{
                        height: 38,
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: 0,
                        marginBottom: 0,
                      }}
                    >
                      ...
                    </PaginationLink>
                  </PaginationItem>
                )}

                <PaginationItem
                  active={selectedPage === page}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <PaginationLink
                    style={{
                      height: 38,
                      display: 'flex',
                      alignItems: 'center',
                      marginTop: 0,
                      marginBottom: 0,
                    }}
                    onClick={() => onPageChange(page)}
                  >
                    {page + 1}
                  </PaginationLink>
                </PaginationItem>
              </Fragment>
            );
          })}

          <PaginationItem
            disabled={selectedPage + 1 >= totalPages}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <PaginationLink
              next
              style={{
                height: 38,
                display: 'flex',
                alignItems: 'center',
                marginTop: 0,
                marginBottom: 0,
              }}
              onClick={() => onPageChange(selectedPage + 1)}
            />
          </PaginationItem>
        </Pagination>
      </div>
    </div>
  );
};
